module.exports = __webpack_public_path__ + "img/licensed-lender.f421cb5.png";